import axios from 'axios'
import { addAuthInterceptor, addErrorInterceptor } from './factory/AxiosInterceptors';

const uidataApi = axios.create({
  baseURL: process.env.BASE_URL + 'api/uidata',
  timeout: 10000
});

addAuthInterceptor(uidataApi);
addErrorInterceptor(uidataApi,
  // Default error payload
  { kpiCodes: [], kpiGroupCodes: [] }
);

export default {
  // baseURL: process.env.BASE_URL + 'api/kpi',

  async getSearchOptions(clientId, currentLocale, mode) {
    const payload = { clientId, mode, localizationId: currentLocale };
    const response = await uidataApi.post('/search-options', payload);
    return response.data;
  },

  async getDetails(clientId, currentLocale, kpi) {
    const payload = { kpiCode: kpi.label, type: kpi.type, clientId, localizationId: currentLocale };
    const response = await uidataApi.post('/details', payload);
    return response.data;
  },

  async getPageDetails(clientId, pageName, currentLocale) {
    const payload = { clientId: clientId, page: pageName, localizationId: currentLocale };
    const response = await uidataApi.post('/read-page-details', payload);
    return response.data;
  },

  async writePageDetails(clientId, pageName, currentLocale, data) {
    const payload = { page: pageName, data: JSON.stringify(data) };
    const response = await uidataApi.post('/write-page-details', payload);
    return response.data;
  },

  async createView(clientId, pageName, currentLocale, viewData) {
    const payload = {
      clientId: clientId,
      page: pageName,
      localizationId: currentLocale,
      name: viewData.name,
      description: viewData.description,
      copyCurrentLayout: viewData.copyCurrentLayout,
      isGeneric: viewData.isGeneric || false,
      sourceViewId: viewData.sourceViewId
    };
    const response = await uidataApi.post('/create-view', payload);
    return response.data;
  },

  async readView(clientId, pageName, activeViewId, currentLocale) {
    const payload = { clientId: clientId, page: pageName, activeViewId: activeViewId, localizationId: currentLocale };
    const response = await uidataApi.post('/read-view', payload);
    return response.data;
  },

  async updateView(clientId, currentLocale, view) {
    log.error("/update-view", view);
    const response = await uidataApi.post('/update-view', view);
    return response.data;
  },

  async deleteView(viewId) {
    const response = await uidataApi.delete(`/view/${viewId}`);
    return response.data;
  }
};
